import { LoadableLazy } from '@confluence/loadable';

export const LazyGiveFeedbackDialog = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GiveFeedbackDialog" */ './GiveFeedbackDialog.tsx'))
			.GiveFeedbackDialog,
});
